export default "__VITE_ASSET__DHQP14M7__"